module.exports = __webpack_public_path__ + "img/examoutline.66f88426.png";